import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Card, CardFooter, CardHeader, Container, Modal, ModalBody, ModalHeader, ModalFooter, Row, Table, Input } from "reactstrap";
import { PiFlowerFill } from "react-icons/pi";
import TablePagination from "views/components/TablePagination";
import { filterItems } from "lib/helper";
import ExportButton from "components/ExportButton";
import experienceModel from "models/experience.model";
import { helper } from "lib/helper";
import TableHeader from "components/TableHeader/TableHeader";

const Listing = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [modal, setModal] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [trandingCats, setTrandingCats] = useState([]);
  const [selectedCats, setSelectedCats] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [experienceId, setExperienceId] = useState(null);


  const location = useLocation();
  const navigate = useNavigate();

  const toggleModal = (description = "") => {
    setSelectedDescription(description);
    setModal(!modal);
  };

  const options = [
    "#",
    "Buddy (Mobile)",
    "Experience Title",
    "Description",
    "Goods & Services",
    "Audience For",
    "Actions",
  ];

  const getListData = async () => {
    setIsLoading(true);
    try {
      const result = await experienceModel.listing();
      if (result) {
        setDataList(result?.data?.data);
      }
    } catch (error) {
      helper.sweetalert.toast(error.response?.data?.message, "warning");
    } finally {
      setIsLoading(false);
    }
  };
  const handleExperieneUpdate = (id, approved_by_admin) => {
    let text = approved_by_admin ? 'Approved' : 'Rejected';
    helper.sweetalert
      .confirm(
        `Are You sure you want to mark as approve clover ? `,
        "info",
        true
      )
      .then((result) => {
        if (result.isConfirmed) {
          experienceModel.editExperienceDetails({ approved_by_admin }, id).then((res) => {
            helper.sweetalert.toast(res?.data?.message);
            getListData();
          });
        }
      });
  };
  const updateCategories = async () => {
    try {
      await experienceModel.editExperienceDetails({ trandingCategory: selectedCats }, experienceId);
      helper.sweetalert.toast("Trending categories updated", "success");
      setShowModal(false);
    } catch (err) {
      console.log(err);
      helper.sweetalert.toast("Update failed", "error");
    }
  };

  const handleExperieneUpdate1 = (id, published_by_admin) => {
    let text = published_by_admin ? 'Approved' : 'Rejected';


    helper.sweetalert
      .confirm(
        `Are You sure you want to mark this experience as ? ${text} `,
        "info",
        true
      )
      .then((result) => {
        if (result.isConfirmed) {

          experienceModel.editExperienceDetails({ published_by_admin }, id).then((res) => {
            helper.sweetalert.toast(res?.data?.message);
            getListData();
          });
        }
      });
  };

  const handleDel = async (delId) => {
    const result = await helper.sweetalert.confirm(
      "Are you sure you want to delete this listing?",
      "info",
      true
    );
    if (result.isConfirmed) {
      try {
        const res = await experienceModel.experienceDelete(delId);
        helper.sweetalert.toast(res.data?.message);
        getListData();
      } catch (error) {
        helper.sweetalert.toast("Failed to delete listing", "error");
      }
    }
  };

  const getTrandingCategory = async () => {
    try {
      const tranding_cats_response = await experienceModel.getTrandingCategory();
      let tranding_cats = tranding_cats_response?.data?.data;
      setTrandingCats(tranding_cats);

    } catch (error) {
      console.log(error);
      helper.sweetalert.toast("Failed to get tranding categories", "error");
    }
  };

  const assignTrandingCats = async (expId, assignedCategory) => {
    try {

      const assignedCats = assignedCategory;
      setExperienceId(expId);
      setSelectedCats(assignedCats);
      setShowModal(true);

    } catch (error) {
      console.log(error);
      helper.sweetalert.toast("Failed to assing tranding categories", "error");
    }
  };

  const toggleCategory = (cat_name) => {
    setSelectedCats(prev => prev.includes(cat_name) ? prev.filter(x => x !== cat_name) : [...prev, cat_name]);
  };


  useEffect(() => {
    getListData();
    getTrandingCategory();
  }, [location]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, fromDate, toDate]);

  const dateFilteredList = dataList.filter((item) => {
    const createdAt = new Date(item.createdAt);
    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;
    return (!from || createdAt >= from) && (!to || createdAt <= to);
  });

  const filteredDataList = filterItems(
    dateFilteredList.map((e) => ({ ...e.hostedBy, ...e })),
    searchQuery,
    ["firstName", "lastName", "mob", "title", "description", "services", "audienceFor"]
  );
  const startIndex = (currentPage - 1) * perPage;
  const paginatedDataList = filteredDataList.slice(startIndex, startIndex + perPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const columnsConfig = [
    {
      label: "S.No",
      getValue: (_, index) => startIndex + index + 1
    },
    {
      label: "Buddy (Mobile)",
      getValue: (item) => `${item?.hostedBy?.firstName} ${item?.hostedBy?.lastName} (${item?.hostedBy?.mobileNo})`,
    },
    {
      label: "Experience Title",
      getValue: (item) => item?.title
    },
    {
      label: "Description",
      getValue: (item) => item.description.length > 100 ? item.description.substring(0, 100) + "..." : item.description,
    },
    {
      label: "Goods",
      getValue: (item) => item?.goodsOrServices?.join(", "),
    },
    {
      label: "Audience For",
      getValue: (item) => item?.intendedAudience.name?.join(", "),
    },
  ];


  return (
    <Container className="pt-7" fluid>
      {!isLoading && (
        <Row>
          <div className="col pl-0 pr-0">
            <Card className="shadow">
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Buddy Experiences</h3>
                <div className="d-flex align-items-center">
                  <div>
                    <lebal className="text-sm">Search</lebal>
                    <Input
                      type="text"
                      placeholder="Search Here..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{ width: "200px", marginRight: "10px" }}
                    />
                  </div>
                  <div>
                    <lebal className="text-sm">To date</lebal>
                    <Input
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      style={{ marginRight: "10px" }}
                    />
                  </div>
                  <div className="ml-2">
                    <lebal className="">Form date</lebal>
                    <Input
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      style={{ marginRight: "10px" }}
                    />
                  </div>
                  <div className=" ml-3 mt-4">
                    <ExportButton data={filteredDataList} columnsConfig={columnsConfig} />
                  </div>
                </div>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <TableHeader options={options} />
                <tbody>
                  {paginatedDataList.map((item, index) => (
                    <tr key={item._id}>
                      <td>{startIndex + index + 1}</td>
                      <td>{`${item?.hostedBy?.firstName} ${item?.hostedBy?.lastName} (${item?.hostedBy?.mobileNo})`}</td>
                      <td>{item?.title}</td>
                      <td>{item?.description?.length > 50 ? item?.description.slice(0, 50) + "..." : item?.description} </td>
                      <td>{item?.goodsOrServices?.join(", ")}</td>
                      <td>{item?.intendedAudience?.map((audience) => audience?.name).join(", ").slice(0, 50) + "..."}</td>
                      <td>
                        {item?.approved_by_admin === false ? (
                          <PiFlowerFill
                            className="mr-2 text-primary"
                            style={{ fontSize: "23px", cursor: "pointer" }}
                            onClick={() => { handleExperieneUpdate(item._id, true) }} />) : (<PiFlowerFill className="mr-2  text-danger " style={{ fontSize: "23px", cursor: "pointer" }}
                              onClick={() => { handleExperieneUpdate(item._id, false) }} />)
                        }

                        {item?.published_by_admin === false ?
                          (<Button color="info" size="sm" onClick={() => handleExperieneUpdate1(item._id, true)}>
                            <i className="fa-solid fa-check"></i>
                          </Button>) :
                          (<Button color="warning" size="sm" onClick={() => handleExperieneUpdate1(item._id, false)}>
                            <i className="fa-solid fa-xmark"></i>
                          </Button>)
                        }
                        <Button color="success" size="sm" onClick={() => navigate(`/admin/listings/experience-details/${item._id}`)} >
                          <i className="fa-solid fa-eye"></i>
                        </Button>
                        <Button color="warning" size="sm" onClick={() => navigate(`/admin/listings/edit-experience-details/${item._id}`)}>
                          <i className="fa-regular fa-pen-to-square"></i>
                        </Button>
                        <Button color="danger" size="sm" onClick={() => handleDel(item._id)}>
                          <i className="fa-solid fa-trash"></i>
                        </Button>
                        <Button color="info" size="sm" onClick={() => assignTrandingCats(item._id, item?.trandingCategory)}>
                          <i className="fa-solid fa-tags"></i>
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <TablePagination
                  totalPages={Math.ceil(filteredDataList.length / perPage)}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </CardFooter>
            </Card>
          </div>
        </Row>
      )}

      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Full Description</ModalHeader>
        <ModalBody>{selectedDescription}</ModalBody>
      </Modal>

      {showModal && (
        <Modal isOpen={showModal} toggle={() => setShowModal(false)} size="lg">
          <ModalHeader toggle={() => setShowModal(false)}>
            Assign Trending Categories
          </ModalHeader>

          <ModalBody>
            <div className="row">
              {trandingCats.map(cat => (
                <div className="col-md-4 mb-3" key={cat.name}>
                  <div
                    className={`border rounded p-2 h-100 d-flex align-items-center gap-3 cursor-pointer ${selectedCats.includes(cat.name) ? "border-primary bg-light" : ""}`}
                    onClick={() => toggleCategory(cat.name)}
                  >
                    <input
                      type="checkbox"
                      checked={selectedCats.includes(cat.name)}
                      onChange={() => { }}
                      className="form-check-input m-0"
                    />
                    <img
                      src={cat.image}
                      alt={cat.name}
                      width="42"
                      height="42"
                      style={{ objectFit: "cover", borderRadius: "6px" }}
                    />
                    <div className="fw-semibold">{cat.name}</div>
                  </div>
                </div>
              ))}
            </div>
          </ModalBody>

          <ModalFooter>
            <Button color="secondary" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button color="primary" onClick={updateCategories}>
              Update
            </Button>
          </ModalFooter>
        </Modal>
      )}



    </Container>


  );
};

export default Listing;
